<template>
    <div>
        <ts-page-title :title="$t('leaveRecord.pageTitle')" :breadcrumb="[
            { text: $t('home'), href: '/' },
            {
                text: $t('leaveRecord.pageTitle'),
                active: true
            }
        ]" />
        <ts-panel>
            <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
                <Button type="info" ghost @click="$router.push({ name: 'leave-record-create' })">{{ $t("addNew") }}
                </Button>
                <div class="ts-justify-end ts-space-x-2">
                    <Input search v-model="search" :placeholder="$t('leaveRecord.search')" :style="width"
                        @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
                    <ts-button v-tooltip="$t('filter')" @click.prevent="visible = true">
                        <i class="fa fa-filter"></i>
                    </ts-button>
                </div>
            </ts-panel-wrapper>
            <div class="overflow-auto">
                <Table :loading="loading" 
										class="ts-whitespace-nowrap " 
										:data="resources" 
										:columns="columns" 
										size="small"
										highlight-row
                    stripe
										max-height="700">
											  <template slot-scope="{ row }" slot="photo">
															<img class="ts-rounded ts-h-12" v-lazy="{
																	src: photo(row),
																	error:
																			row.sex == 'Male'
																					? require('@/assets/staff-default-man.png')
																					: require('@/assets/staff-default-women.png'),
																	loading: require('@/assets/Rolling-1s-200px.svg'),
																	preLoad: 1.3,
																	attempt: 1
															}" />
											  </template>
												<template slot-scope="{ row }" slot="employeeName">
													<td width="150px" class="ts-align-middle ts-whitespace-no-wrap" style="border-bottom: none;">
															{{ row.employee ? row.employee.employee_name_en : '' }} |
															{{ row.employee ? row.employee.employee_name_kh : '' }}
													</td>
											  </template>
												<template slot-scope="{ row }" slot="leaveType">
													<td width="380px" class="ts-align-middle ts-whitespace-no-wrap" style="border-bottom: none;">
															<span :class="leaveTypeColor(row.leave_type_id)">
																	{{ row.leave_type ? row.leave_type.leave_type_en : '' }} |
																	{{ row.leave_type ? row.leave_type.leave_type_kh : '' }}
															</span>
													</td>
											  </template>
												<template slot-scope="{ row }" slot="fromDate">
													<td width="150px" style="border-bottom: none; text-align: center;">
                            <span class="text-blue ts-font-bold">{{ row.date_from }}</span>
                          </td>
											  </template>
												<template slot-scope="{ row }" slot="leaveSubItem">
													<td width="150px" class="ts-align-middle ts-text-center" style="border-bottom: none;">
															{{
																			row.leave_type_sub_item
																					? row.leave_type_sub_item.leave_sub_item
																					: null
															}}
													</td>
												</template>
                        <template slot-scope="{ row }" slot="action">
                            <a href="#" class="text-primary ml-2" @click.prevent="onEdit(row)"
                                v-tooltip="$t('edit')">
                                <Icon type="ios-create" size="20" />
                            </a>
                            <Poptip :title="$t('are_you_sure_to_delete')" :transfer="true" width="240"
                                v-if="!row._deleting" @on-popper-show="
                                    () => (model.deleted_reason = '')
                                ">
                                <a class="text-danger" v-tooltip="$t('delete')" :disabled="row._deleting">
                                    <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
                                    <Icon type="ios-trash" size="20" v-else />
                                </a>
                                <div slot="content">
                                    <label class="required">{{
                                            $t("leaveRecord.reason")
                                    }}</label>
                                    <input v-model.trim="model.deleted_reason" type="text" class="form-control" :class="{
                                        'is-invalid':
                                            errors.has('deleted_reason') ||
                                            $v.model.deleted_reason.$error
                                    }" />
                                    <span class="invalid-feedback" v-if="reasonErrors.length > 0">{{ reasonErrors[0]
                                    }}</span>
                                    <div class="invalid-feedback" v-if="errors.has('deleted_reason')">
                                        {{ errors.first("deleted_reason") }}
                                    </div>
                                    <div class="ts-mt-2 ts-text-right">
                                        <a class="ivu-btn ivu-btn-primary ivu-btn-small"
                                            @click.prevent="onDelete(row)">
                                            <span>OK</span>
                                        </a>
                                    </div>
                                </div>
                            </Poptip>
												</template>
                </Table>
            </div>
            <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
                <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
            </div>
        </ts-panel>
        <Drawer :title="$t('filter')" :closable="false" :value="visible" @on-close="() => (visible = false)"
            width="300px">
            <div class="mb-3">
                <label class="form-col-label control-label">{{
                        $t('branchName')
                }}</label>
                <ts-branch-filter @filter="value => (branch_id = value)" />
            </div>
        </Drawer>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
import { required } from "vuelidate/lib/validators";
import { Errors } from "form-backend-validation";
export default {
    name: "leave-recordIndex",
    data() {
        return {
            loading: false,
            errors: new Errors(),
            width: "width: 300px",
            visible: false,
            branch_id: [],
            model: {
                deleted_reason: ""
            }
        };
    },
    validations: {
        model: {
            deleted_reason: { required }
        },
        form: ["model.deleted_reason"]
    },
    computed: {
        ...mapState("humanResource/leaveRecord", ["resources", "pagination"]),
        search: {
            get() {
                return this.$store.state.humanResource.leaveRecord.search;
            },
            set(newValue) {
                this.$store.commit(
                    "humanResource/leaveRecord/SET_SEARCH",
                    newValue
                );
                this.$store.commit(
                    "humanResource/leaveRecord/RESET_CURRENT_PAGE"
                );
            }
        },
        reasonErrors() {
            const errors = [];
            if (!this.$v.model.deleted_reason.$error) return errors;
            !this.$v.model.deleted_reason.required && errors.push("Required");
            return errors;
        },
        columns() {
            return [
                {
                    title: this.$t("leaveRecord.photo"),
										slot: 'photo',
										width: 80
                },
                {
                    title: this.$t("leaveRecord.employeeName"),
										sortable: true,
										width: 240,
                    slot: 'employeeName'
                },
                {
                    title: this.$t("leaveRecord.leaveType"),
                    slot: 'leaveType',
										sortable: true,
										width: 320
                },
                {
                    title: this.$t("leaveRecord.dateFrom"),
                    align: 'center',
										sortable: true,
                    slot: 'fromDate'
                },
                {
                    title: this.$t("leaveRecord.timeFrom"),
										key: 'time_from',
                    align: 'center'
                },
                {
                    title: this.$t("leaveRecord.dateTo"),
                    align: 'center',
										sortable: true,
                    key: 'date_to'
                },
                {
                    title: this.$t("leaveRecord.timeTo"),
										key: 'time_to',
                    align: 'center'
                },
                {
                    title: this.$t("leaveRecord.total"),
										key: 'total_day',
                    align: 'center'
                },
                {
                    title: this.$t("leaveRecord.reason"),
										key: 'leave_reason'
                },
                {
                    title: this.$t("leaveRecord.leaveSubItem"),
										slot: 'leaveSubItem',
                    style: "text-align:center"
                },
								{
									title: this.$t('actions'),
									key: 'action',
									slot: 'action',
									fixed: 'right',
									align: 'center',
									width: 94
								}
            ];
        }
    },
    methods: {
        photo(record) {
            if (record.photo) {
                return record.photo;
            }

            return record.sex == "female"
                ? require("@/assets/staff-default-women.png")
                : require("@/assets/staff-default-man.png");
        },
        fetchData(attributes) {
            this.loading = true;
            this.$store
                .dispatch("humanResource/leaveRecord/fetch", attributes)
                .catch(error => {
                    this.loading = false;
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onEdit(record) {
            this.$store.commit(
                "humanResource/leaveRecord/SET_EDIT_DATA",
                record
            );
            this.$router.push({
                name: "leave-record-edit",
                params: { id: record.lr_id }
            });
        },

        async onDelete(record) {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;

            record._deleting = true;
            console.log(this.model);
            this.$store
                .dispatch("humanResource/leaveRecord/destroy", {
                    id: record.lr_id,
                    data: this.model
                })
                .then(response => {
                    this.fetchData();
                    record._deleting = false;
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                    record._deleting = false;
                });
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "leave Record",
                desc: not.text
            });
        },
        leaveTypeColor(leave_type_id)
        {
            if(leave_type_id == 1)
            {
                return 'text-success';
            }else if(leave_type_id == 2)
            {
                return 'text-primary';
            }else if(leave_type_id == 3)
            {
                return 'text-indigo';
            }else if(leave_type_id == 4)
            {
                return 'text-orange';
            }else if(leave_type_id == 5)
            {
                return 'text-danger';
            }else if(leave_type_id == 5)
            {
                return 'text-pink';
            }
        }
    },
    watch: {
        search: debounce(function (search) {
            this.fetchData({ search });
        }, 500),
        branch_id: debounce(function (value) {
            this.fetchData({ branch_id: value });
        }, 500)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchData()
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("humanResource/leaveRecord/RESET_STATE");
        next();
    }
};
</script>
<style scoped>
.text-nowrap {
    white-space: nowrap;
}
</style>
